import {ExampleCategory, exampleNameToId, ExampleOptions, ExamplePrefix} from './Common';
import {Example} from './Example';
import {examplePath, exampleUrl} from '../../routes';
import {
	CameraSopNodeType,
	NetworkNodeType,
	NodeContext,
} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {MapUtils} from '../../../@polygonjs/polygonjs/src/core/MapUtils';
import {ExpressionType} from '../../../@polygonjs/polygonjs/src/engine/expressions/methods/Common';
import {CameraNodeType} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {JsType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Js';
import {AnimType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Anim';
import {GlType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Gl';
import {MatType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Mat';
import {RopType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Rop';
import {SopType, SopTypeFile} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Sop';
import {CopType} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Cop';

export class ExamplesRegisterClass {
	private _examplesByName: Map<string, Example> = new Map();
	private _examplesByPath: Map<string, Example> = new Map();
	private _examplesById: Map<string, Example> = new Map();
	private _examplesByNodeTypeByContext: Map<NodeContext, Map<string, Example[]>> = new Map();
	private _examplesByCategory: Map<ExampleCategory, Example[]> = new Map();
	private _examplesByExpression: Map<ExpressionType, Example[]> = new Map();
	private static _instance: ExamplesRegisterClass;
	static instance() {
		return (this._instance = this._instance || new ExamplesRegisterClass());
	}
	private constructor() {
		//
		//
		// actor
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/actor/AnimationMixer/onScenePlay`,
			categories: [ExampleCategory.STATE_AND_EVENTS],
			relatedNodeContextAndTypes: [{context: NodeContext.JS, type: JsType.ON_SCENE_PLAY}],
			label: 'Animate On Play',
			createData: () => import('./examples/actor/AnimationMixer_onScenePlay'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/actor/OnObjectAttributeUpdate/cameraNavigation`,
			categories: [ExampleCategory.STATE_AND_EVENTS],
			relatedNodeContextAndTypes: [{context: NodeContext.JS, type: JsType.ON_OBJECT_ATTRIBUTE_UPDATE}],
			createData: () => import('./examples/actor/OnObjectAttributeUpdate'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/actor/setObjectLookAt/camera`,
			categories: [ExampleCategory.STATE_AND_EVENTS],
			relatedNodeContextAndTypes: [{context: NodeContext.JS, type: JsType.SET_OBJECT_LOOK_AT}],
			label: 'Objects Look At Camera',
			createData: () => import('./examples/actor/SetObjectLookAt_camera'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/actor/setObjectLookAt/cursor`,
			categories: [ExampleCategory.STATE_AND_EVENTS],
			relatedNodeContextAndTypes: [{context: NodeContext.JS, type: JsType.SET_OBJECT_LOOK_AT}],
			label: 'Objects Look At Cursor',
			createData: () => import('./examples/actor/SetObjectLookAt_cursor'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.COMPUTER_VISION}/${ExampleCategory.PHYSICS}`,
			categories: [ExampleCategory.PHYSICS, ExampleCategory.COMPUTER_VISION],
			createData: () => import('./examples/actor/TrackHand_physics'),
		});

		//
		//
		// anim
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/anim/easing`,
			relatedNodeContextAndTypes: [{context: NodeContext.ANIM, type: AnimType.EASING}],
			categories: [ExampleCategory.ANIMATION],
			createData: () => import('./examples/anim/Easing'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/anim/target/Animate Nodes`,
			relatedNodeContextAndTypes: [{context: NodeContext.ANIM, type: AnimType.TARGET}],
			categories: [ExampleCategory.ANIMATION],
			createData: () => import('./examples/anim/Target.Node'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/anim/target/Animate Scene Graph`,
			relatedNodeContextAndTypes: [{context: NodeContext.ANIM, type: AnimType.TARGET}],
			categories: [ExampleCategory.ANIMATION],
			createData: () => import('./examples/anim/Target.SceneGraph'),
		});

		//
		//
		// mat
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/lineBasic`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.LINE_BASIC}],
			createData: () => import('./examples/mat/LineBasic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/grass`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.LINE_BASIC_BUILDER}],
			createData: () => import('./examples/mat/LineBasicBuilder_grass'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshBasic`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC}],
			createData: () => import('./examples/mat/MeshBasic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshBasicBuilder/blink_multiple`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER}],
			createData: () => import('./examples/mat/MeshBasicBuilder_blink_multiple'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/blink_on_hover_with_instances`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER}],
			createData: () => import('./examples/mat/MeshBasicBuilder_blink_on_hover_with_instances'),
		});
		this._registerAsync({
			// name: `${ExamplePrefix.BY_NODE}/mat/meshBasicBuilder/blink_on_hover_with_separate_objects`,
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/blink_on_hover_with_separate_objects`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.JS, type: JsType.ON_OBJECT_HOVER}],
			createData: () => import('./examples/mat/MeshBasicBuilder_blink_on_hover_with_instances'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshBasicBuilder/blink_single`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER}],
			createData: () => import('./examples/mat/MeshBasicBuilder_blink_single'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/texture_transition`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER},
				{context: NodeContext.GL, type: GlType.NOISE},
			],
			createData: () => import('./examples/mat/MeshBasicBuilder_texture_transition'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshLambert`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_LAMBERT}],
			createData: () => import('./examples/mat/MeshLambert'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshMatcap`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_MATCAP}],
			createData: () => import('./examples/mat/MeshMatcap'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshNormal`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_NORMAL}],
			createData: () => import('./examples/mat/MeshNormal'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshPhong`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_PHONG}],
			createData: () => import('./examples/mat/MeshPhong'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshPhysical`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_PHYSICAL}],
			createData: () => import('./examples/mat/MeshPhysical'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/transmission_animation`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_PHYSICAL_BUILDER}],
			createData: () => import('./examples/mat/MeshPhysicalBuilder_tranmission_animation'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshStandard`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_STANDARD}],
			createData: () => import('./examples/mat/MeshStandard'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/texture_distortion`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_STANDARD_BUILDER}],
			createData: () => import('./examples/mat/MeshStandardBuilder_texture_distortion'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshToon`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_TOON}],
			createData: () => import('./examples/mat/MeshToon'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/points`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.POINTS}],
			createData: () => import('./examples/mat/Points'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/usingAreaLights`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER},
				{context: NodeContext.MAT, type: MatType.MESH_STANDARD_BUILDER},
				{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER},
			],
			createData: () => import('./examples/mat/RayMarchingBuilder_areaLights'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/multishapes`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER},
				{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER},
			],
			createData: () => import('./examples/mat/RayMarchingBuilder_multishapes'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/primitives`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER}],
			createData: () => import('./examples/mat/RayMarchingBuilder_primitives'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/reflections`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER}],
			createData: () => import('./examples/mat/RayMarchingBuilder_reflections'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/refractions`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER},
				{context: NodeContext.JS, type: JsType.ON_PERFORMANCE_CHANGE},
			],
			createData: () => import('./examples/mat/RayMarchingBuilder_refractions'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/rayMarchingBuilder/SDFFromObject`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER}],
			createData: () => import('./examples/mat/RayMarchingBuilder_SDFFromObject'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CUSTOM_MATERIALS}/raymarchingShadows`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER}],
			createData: () => import('./examples/mat/RayMarchingBuilder_shadows'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.AR}/${ExampleCategory.CUSTOM_MATERIALS}/raymarching`,
			categories: [ExampleCategory.CUSTOM_MATERIALS, ExampleCategory.AR],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.RAY_MARCHING_BUILDER}],
			createData: () => import('./examples/mat/RayMarchingBuilder_WebXRAR'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/shadow`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.SHADOW}],
			createData: () => import('./examples/mat/Shadow'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/sky`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.SKY}],
			createData: () => import('./examples/mat/Sky'),
		});

		//
		//
		// sop
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/add/Create Line`,
			createData: () => import('./examples/sop/Add.createLine'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/add/Create Points`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ADD}],
			createData: () => import('./examples/sop/Add'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/attribAddMult`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ATTRIB_ADD_MULT}],
			createData: () => import('./examples/sop/AttribAddMult'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/attribCopy`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ATTRIB_COPY}],
			createData: () => import('./examples/sop/AttribCopy'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/attribCreate`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ATTRIB_CREATE}],
			createData: () => import('./examples/sop/AttribCreate'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/blend`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.BLEND}],
			createData: () => import('./examples/sop/Blend'),
		});
		// this._registerAsync({
		// 	name: `${ExamplePrefix.BY_NODE}/sop/blend`,
		// 	relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.BLEND}],
		// 	createData: () => import('./examples/sop/Blend'),
		// });
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/box`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.BOX}],
			createData: () => import('./examples/sop/Box'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.AR}/basic`,
			categories: [ExampleCategory.AR],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraSopNodeType.WEBXR_AR}],
			createData: () => import('./examples/sop/CameraWebXRAR.basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.CONTROLS}/FirstPersonControls`,
			categories: [ExampleCategory.CONTROLS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.BVH}],
			createData: () => import('./examples/controls/firstPersonControls.BVH_compact'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.AR}/controllerRay`,
			categories: [ExampleCategory.AR],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraSopNodeType.WEBXR_AR}],
			createData: () => import('./examples/sop/CameraWebXRAR.controllerRay'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.AR}/controllerRay2`,
			categories: [ExampleCategory.AR],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraSopNodeType.WEBXR_AR}],
			createData: () => import('./examples/sop/CameraWebXRAR.controllerRay2'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.VR}/basic`,
			categories: [ExampleCategory.VR],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraSopNodeType.WEBXR_VR}],
			createData: () => import('./examples/sop/CameraWebXRVR.basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/copy/materialsAndTextures`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.COPY}],
			createData: () => import('./examples/sop/Copy_materialsAndTextures'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/instancing/stairsAreFun/stairCaseFPS`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.COPY}],
			createData: () => import('./examples/sop/Copy_stairCaseFPS'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/instancing/stairsAreFun/stairCaseMultiple`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.COPY}],
			createData: () => import('./examples/sop/Copy_stairCaseMultiple'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/instancing/stairsAreFun/stairCaseSimple`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.COPY}],
			createData: () => import('./examples/sop/Copy_stairCaseSimple'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/copy/withTemplateAttributes`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.COPY}],
			createData: () => import('./examples/sop/Copy_withTemplateAttributes'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/CSS2DObject/basic`,
			categories: [ExampleCategory.HTML_IN_3D],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.CSS2D_OBJECT},
				{context: NodeContext.ROP, type: RopType.CSS2D},
			],
			createData: () => import('./examples/sop/CSS2DObject_basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/CSS2DObject/clickable`,
			categories: [ExampleCategory.HTML_IN_3D],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.CSS2D_OBJECT},
				{context: NodeContext.ROP, type: RopType.CSS2D},
			],
			createData: () => import('./examples/sop/CSS2DObject_clickable'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/CSS2DObject/fromData`,
			categories: [ExampleCategory.HTML_IN_3D],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.CSS2D_OBJECT},
				{context: NodeContext.ROP, type: RopType.CSS2D},
			],
			createData: () => import('./examples/sop/CSS2DObject_fromData'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/CSS3DObject/basic`,
			categories: [{category: ExampleCategory.HTML_IN_3D, label: 'basic 3D'}],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.CSS3D_OBJECT},
				{context: NodeContext.ROP, type: RopType.CSS3D},
			],
			createData: () => import('./examples/sop/CSS3DObject_basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/actor/buttons_3D`,
			categories: [{category: ExampleCategory.HTML_IN_3D, label: '3D Buttons'}],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ACTOR}],
			createData: () => import('./examples/sop/ClickableObjects'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/data/advanced`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.DATA}],
			createData: () => import('./examples/sop/Data_advanced'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/data/advancedWithCopy`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.DATA}],
			createData: () => import('./examples/sop/Data_advancedWithCopy'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/data/basic`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.DATA}],
			createData: () => import('./examples/sop/Data_basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/dataUrl`,
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.DATA_URL}],
			createData: () => import('./examples/sop/DataUrl'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/Decompose/basic`,
			label: 'Edit Materials After Import',
			categories: [ExampleCategory.ASSETS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: NetworkNodeType.DECOMPOSE}],
			createData: () => import('./examples/sop/Decompose_basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/file`,
			categories: [ExampleCategory.ASSETS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopTypeFile.FILE_OBJ}],
			createData: () => import('./examples/sop/File'),
		});
		// this._registerAsync({
		// 	name: `${ExamplePrefix.BY_NODE}/sop/fileIFC`,
		// 	label: 'IFC',
		// 	categories: [ExampleCategory.ASSETS],
		// 	relatedNodeContextAndTypes: [
		// 		{context: NodeContext.SOP, type: SopTypeFile.FILE_IFC},
		// 		{context: NodeContext.SOP, type: SopType.IFC_FILTER_CATEGORIES},
		// 	],
		// 	createData: () => import('./examples/sop/FileIFC'),
		// });
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/fileGEOJSON`,
			label: 'GEOJSON',
			categories: [ExampleCategory.ASSETS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopTypeFile.FILE_GEOJSON}],
			createData: () => import('./examples/sop/FileGEOJSON'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/instance/withTemplateAttributes`,
			label: 'With Template Attributes',
			categories: [{category: ExampleCategory.INSTANCING, label: 'withTemplateAttributes (instances)'}],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.INSTANCE}],
			createData: () => import('./examples/sop/Instance_withTemplateAttributes'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/instance`,
			label: 'Basic',
			categories: [ExampleCategory.INSTANCING],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.INSTANCE}],
			createData: () => import('./examples/sop/Instance'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MAPS}/basic`,
			categories: [ExampleCategory.MAPS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: CameraNodeType.MAPBOX},
				{context: NodeContext.SOP, type: SopType.MAPBOX_TRANSFORM},
			],
			createData: () => import('./examples/sop/MapboxCamera.basic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MAPS}/placeSingleObject`,
			categories: [ExampleCategory.MAPS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraNodeType.MAPBOX}],
			createData: () => import('./examples/sop/MapboxPlaceSingleObject'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MAPS}/placeObjectsFromPool`,
			categories: [ExampleCategory.MAPS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraNodeType.MAPBOX}],
			createData: () => import('./examples/sop/MapboxPlaceObjectsFromPool'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MAPS}/placeObjectsProcedurally`,
			categories: [ExampleCategory.MAPS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: CameraNodeType.MAPBOX}],
			createData: () => import('./examples/sop/MapboxPlaceObjectsProcedurally'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MAPS}/html2D`,
			categories: [ExampleCategory.MAPS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: CameraNodeType.MAPBOX},
				{context: NodeContext.SOP, type: SopType.MAPBOX_TRANSFORM},
				{context: NodeContext.ROP, type: RopType.CSS2D},
			],
			createData: () => import('./examples/sop/MapboxCamera.html2D'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/noise`,
			// categories: [ExampleCategory.EFFECTS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.NOISE}],
			createData: () => import('./examples/sop/Noise'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/Particles/polygonjsLogo`,
			categories: [ExampleCategory.EFFECTS],
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.PARTICLES_SYSTEM_GPU}],
			createData: () => import('./examples/sop/ParticlesSystemGPU_polygonjsLogo'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/actor/setObjectLookAt/ClickedObject`,
			categories: [ExampleCategory.STATE_AND_EVENTS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: CameraNodeType.PERSPECTIVE},
				{context: NodeContext.JS, type: JsType.SET_OBJECT_LOOK_AT},
			],
			createData: () => import('./examples/sop/PerspectiveCamera_lookAtClickedObject'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/roundedBox`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.ROUNDED_BOX}],
			createData: () => import('./examples/sop/RoundedBox'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/sphere/icosahedron`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.SPHERE}],
			createData: () => import('./examples/sop/Sphere.icosahedron'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/sphere/default`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.SPHERE}],
			createData: () => import('./examples/sop/Sphere'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/subdivide`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.SUBDIVIDE}],
			createData: () => import('./examples/sop/Subdivide'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/switch`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.SWITCH}],
			createData: () => import('./examples/sop/Switch'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/tetrahedron`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.TETRAHEDRON}],
			createData: () => import('./examples/sop/Tetrahedron'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/torus`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.TORUS}],
			createData: () => import('./examples/sop/Torus'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/torusKnot`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.TORUS_KNOT}],
			createData: () => import('./examples/sop/TorusKnot'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/sop/uvUnwrap`,
			relatedNodeContextAndTypes: [{context: NodeContext.SOP, type: SopType.UV_UNWRAP}],
			createData: () => import('./examples/sop/UvUnwrap'),
		});

		// this._register(sopAddCreateLine);
		// this._register(sopAdd);
		// this._register(sopAttribAddMult);
		// this._register(sopAttribCopy);
		// this._register(sopAttribCreate);
		// this._register(sopBlend);
		// this._register(sopBox);
		// this._register(sopCameraWebXRAR_basic);
		// this._register(sopCameraWebXRAR_controllerRay);
		// this._register(sopCameraWebXRAR_controllerRay2);
		// this._register(sopCameraWebXRVR_basic);
		// this._register(sopCopy_materialsAndTextures);
		// this._register(sopCopy_stairCaseFPS);
		// this._register(sopCopy_stairCaseMultiple);
		// this._register(sopCopy_stairCaseSimple);
		// this._register(sopCopy_withTemplateAttributes);
		// this._register(sopCSS2DObject_basic);
		// this._register(sopCSS2DObject_clickable);
		// this._register(sopCSS3DObject_basic);
		// this._register(sopData_basic);
		// this._register(sopData_advanced);
		// this._register(sopData_advancedWithCopy);
		// this._register(sopDataUrl);
		// this._register(sopDecompose_basic);
		// this._register(sopFile);
		// this._register(sopFileGEOJSON);
		// this._register(sopInstance);
		// this._register(sopInstance_withTemplateAttributes);
		// this._register(sopMapboxCamera_basic);
		// this._register(sopMapboxCamera_HTML2D);
		// this._register(sopNoise);
		// this._register(sopParticlesSystemGPU_polygonjsLogo);
		// this._register(sopPerspectiveCamera_lookAtClickedObject);
		// this._register(sopRoundedBox);
		// this._register(sopSphereIcosahedron);
		// this._register(sopSphere);
		// this._register(sopSubdivide);
		// this._register(sopSwitch);
		// this._register(sopTetrahedron);
		// this._register(sopTorus);
		// this._register(sopTorusKnot);
		// this._register(sopUvUnwrap);

		//
		//
		// expressions
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExamplePrefix.USING_EXPRESSIONS}/bbox`,
			relatedExpressionTypes: [ExpressionType.bbox],
			createData: () => import('./examples/expressions/bbox'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExamplePrefix.USING_EXPRESSIONS}/centroid`,
			relatedExpressionTypes: [ExpressionType.centroid],
			createData: () => import('./examples/expressions/centroid'),
		});

		//
		//
		// advanced
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_NODE}/mat/meshBasicBuilder/CornellBoxLightMaps`,
			label: `CornellBoxLightMaps`,
			categories: [ExampleCategory.CUSTOM_MATERIALS],
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER}],
			createData: () => import('./examples/advanced/CornellBoxLightMaps'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/PsychedelicCar`,
			label: `PsychedelicCar`,
			categories: [ExampleCategory.EFFECTS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.MATERIAL},
				{context: NodeContext.MAT, type: MatType.MESH_STANDARD_BUILDER},
				{context: NodeContext.MAT, type: MatType.MESH_PHYSICAL_BUILDER},
			],
			createData: () => import('./examples/advanced/PsychedelicCar'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/TubesFlowingOnCurves`,
			categories: [ExampleCategory.EFFECTS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.COPY},
				{context: NodeContext.SOP, type: SopType.CURVE_FROM_POINTS},
				{context: NodeContext.SOP, type: SopType.POLYWIRE},
				{context: NodeContext.SOP, type: SopType.RAY},
			],
			createData: () => import('./examples/advanced/TubesFlowingOnCurves'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/Portal`,
			categories: [ExampleCategory.EFFECTS],
			relatedNodeContextAndTypes: [{context: NodeContext.COP, type: CopType.RENDER}],
			createData: () => import('./examples/advanced/Portal'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/VertexAnimationTexture`,
			relatedNodeContextAndTypes: [{context: NodeContext.GL, type: GlType.VERTEX_ANIMATION_TEXTURE}],
			categories: [ExampleCategory.ANIMATION, ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/VertexAnimationTexture_simple'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/lightMap`,
			relatedNodeContextAndTypes: [{context: NodeContext.COP, type: CopType.LIGHT_MAP}],
			categories: [ExampleCategory.RENDER, ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/LightMap'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/cigarSmoke`,
			relatedNodeContextAndTypes: [{context: NodeContext.MAT, type: MatType.MESH_BASIC_BUILDER}],
			categories: [ExampleCategory.RENDER, ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/CigarSmoke'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/clothSolverBasic`,
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.CLOTH_PREPARE},
				{context: NodeContext.SOP, type: SopType.CLOTH_SOLVER},
			],
			categories: [ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/ClothSolverBasic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/softBodySolverBasic`,
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.TETRAHEDRALIZE},
				{context: NodeContext.SOP, type: SopType.TET_SOFT_BODY_SOLVER},
			],
			categories: [ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/SoftBodySolverBasic'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.EFFECTS}/softBodySolverHighRes`,
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.TETRAHEDRALIZE},
				{context: NodeContext.SOP, type: SopType.TET_SOFT_BODY_SOLVER},
				{context: NodeContext.SOP, type: SopType.TET_EMBED},
			],
			categories: [ExampleCategory.EFFECTS],
			createData: () => import('./examples/advanced/SoftBodySolverHighRes'),
		});
		//
		//
		// physics
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.PHYSICS}/RBDAttractorCursor`,
			categories: [ExampleCategory.PHYSICS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.COPY},
				{context: NodeContext.SOP, type: SopType.CURVE_FROM_POINTS},
				{context: NodeContext.SOP, type: SopType.PHYSICS_RBD_ATTRIBUTES},
				{context: NodeContext.SOP, type: SopType.PHYSICS_WORLD},
				{context: NodeContext.JS, type: JsType.SET_PHYSICS_RBD_POSITION},
			],
			createData: () => import('./examples/physics/PhysicsRBDAttractorCursor'),
		});
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.PHYSICS}/basics`,
			categories: [ExampleCategory.PHYSICS],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.COPY},
				{context: NodeContext.SOP, type: SopType.CURVE_FROM_POINTS},
				{context: NodeContext.SOP, type: SopType.PHYSICS_RBD_ATTRIBUTES},
				{context: NodeContext.SOP, type: SopType.PHYSICS_WORLD},
				{context: NodeContext.SOP, type: SopType.PHYSICS_GROUND},
			],
			createData: () => import('./examples/physics/PhysicsRBDSimple'),
		});
		//
		//
		// CAD
		//
		//
		this._registerAsync({
			name: `${ExamplePrefix.BY_CATEGORY}/${ExampleCategory.MODELING}/CAD_basics`,
			categories: [ExampleCategory.MODELING],
			relatedNodeContextAndTypes: [
				{context: NodeContext.SOP, type: SopType.COPY},
				{context: NodeContext.SOP, type: SopType.CAD_BOX},
				{context: NodeContext.SOP, type: SopType.CAD_BOOLEAN},
				{context: NodeContext.SOP, type: SopType.CAD_FILLET},
				{context: NodeContext.SOP, type: SopType.CAD_GROUP},
			],
			createData: () => import('./examples/sop/CAD_fillet'),
		});
	}

	// private _register(examples: Example | Array<Example>) {
	// 	if (CoreType.isArray(examples)) {
	// 		for (let example of examples) {
	// 			this._registerExample(example);
	// 		}
	// 	} else {
	// 		this._registerExample(examples);
	// 	}
	// }
	private _registerAsync(examplesOptions: ExampleOptions) {
		const example = new Example(examplesOptions);
		this._registerExample(example);
	}
	private _registerExample(example: Example) {
		// by name
		const exampleName = example.name();
		const existingExample = this._examplesByName.get(exampleName);
		if (existingExample) {
			console.error(`example name already registered:${exampleName}`);
			return;
		}
		this._examplesByName.set(exampleName, example);

		// by id
		const exampleId = example.id();
		if (this._examplesById.has(exampleId)) {
			console.warn(`example id already registered:${exampleId}`);
			return;
		}
		this._examplesById.set(exampleId, example);

		// by path
		const examplePaths = example.paths();
		for (let examplePath of examplePaths) {
			if (this._examplesByPath.has(examplePath)) {
				console.warn(`example path already registered:${examplePath}`);
				console.log('previously registered:', this._examplesByPath.get(examplePath)?.name());
				return;
			}

			this._examplesByPath.set(examplePath, example);
		}

		// register by related nodes
		const relatedNodeContextAndTypes = example.relatedNodeContextAndTypes();
		if (relatedNodeContextAndTypes) {
			for (let relatedNode of relatedNodeContextAndTypes) {
				const {context, type} = relatedNode;
				let contextMap = this._examplesByNodeTypeByContext.get(context);
				if (!contextMap) {
					contextMap = new Map();
					this._examplesByNodeTypeByContext.set(context, contextMap);
				}
				MapUtils.pushOnArrayAtEntry(contextMap, type.toLowerCase(), example);
			}
		}
		// register by category
		const categories = example.categories();
		if (categories) {
			for (let category of categories) {
				MapUtils.pushOnArrayAtEntry(this._examplesByCategory, category, example);
			}
		}
		// register by related expressions
		const relatedExpressionTypes = example.relatedExpressionTypes();
		if (relatedExpressionTypes) {
			for (let relatedExpressionType of relatedExpressionTypes) {
				MapUtils.pushOnArrayAtEntry(this._examplesByExpression, relatedExpressionType, example);
			}
		}
	}
	names() {
		const list: string[] = [];
		this._examplesByName.forEach((_, exampleName) => list.push(exampleName));
		return list;
	}
	paths() {
		const list: string[] = [];
		this._examplesByPath.forEach((_, examplePath) => list.push(examplePath));
		return list;
	}
	private _exampleFromName(exampleName: string) {
		const example =
			this.exampleFromName(exampleName) ||
			this.exampleFromId(exampleNameToId(exampleName)) ||
			this.exampleFromPath(exampleName);
		if (!example) {
			console.log('no url found from example name', exampleName);
			return;
		}
		return example;
	}
	route(exampleName: string) {
		const example = this._exampleFromName(exampleName);
		if (!example) {
			console.log('no url found from example name', exampleName);
			return;
		}
		const exampleId = example.id();
		return examplePath(exampleId);
		// const localEditorUrl = window.location.origin;
		// // web editor url should be accessible for non registered users
		// const webEditorUrl = `${window.location.origin}/demo`;
		// const rootUrl = Editor.type() == EditorType.LOCAL ? localEditorUrl : webEditorUrl;
		// const url = `${rootUrl}?${EXAMPLES_REGISTER_URL_PARAM_NAME}=${exampleId}`;
		// return url;
	}
	url(exampleName: string) {
		const example = this._exampleFromName(exampleName);
		if (!example) {
			console.log('no url found from example name', exampleName);
			return;
		}
		const exampleId = example.id();
		return exampleUrl(exampleId);
	}
	exampleFromName(exampleName: string) {
		return this._examplesByName.get(exampleName);
	}
	exampleFromPath(examplePath: string) {
		return this._examplesByPath.get(examplePath);
	}
	exampleFromId(exampleId: string) {
		return this._examplesById.get(exampleId);
	}
	examplesFromNode(context: NodeContext, type: string): Example[] | undefined {
		return this._examplesByNodeTypeByContext.get(context)?.get(type.toLowerCase());
	}
	examplesFromCategory(category: ExampleCategory): Example[] | undefined {
		return this._examplesByCategory.get(category);
	}
	examplesFromExpression(expressionName: ExpressionType): Example[] | undefined {
		return this._examplesByExpression.get(expressionName);
	}
}
export const __ExamplesRegister__ = ExamplesRegisterClass.instance();
